import { useEffect, useRef } from "react";

const usePreviousExisting = <T>(value: T) => {
    const ref = useRef<T>(undefined);

    useEffect(() => {
        if (typeof value !== "undefined" && value !== null) {
            ref.current = value;
        }
    }, [value]);

    return ref.current;
};

export default usePreviousExisting;
